export const MAX_SOCIAL_MEDIA_LENGTH = 100;
